import { Expose, Transform } from "class-transformer";
import { parseApiDate } from "@/utils/dates/dateFormats";
import { toLocaleTimezone } from "@/utils/dates/dateUtils";

export class PlanningBoardTechnicianNearExpirationQualificationDto {
  @Expose()
  userId: string;

  @Expose()
  qualificationName: string;

  @Expose()
  @Transform(({ value }) => toLocaleTimezone(parseApiDate(value)))
  end: Date;

  @Expose()
  isExpired: boolean;
}
